// 更新 single stake 输入值
export const UPDATE_SINGLE_STAKE = 'UPDATE_SINGLE_STAKE'

// betslip 主界面或 quick bet 打开或关闭
export const BETSLIP_VISIBLE = 'BETSLIP_VISIBLE'

// 打开/隐藏红包列表
export const SHOW_VOUCHERS = 'SHOW_VOUCHERS'
